// 银行
export default {
  bankAccountEdit: {
    collapseTitle: {
      bankTitle: '开户银行信息',
      accountTitle: '账户信息',
    },
    bankForm: {
      company: '公司',
      companyPlaceholder: '请选择公司',
      bankCode: '银行代码',
      bankCodePlaceholder: '请选择银行代码',
      bankName: '分行名称',
      bankNamePlaceholder: '自动生成',
      bankNational: '银行国家',
      bankNationalPlaceholder: '自动生成',
      branch: '分行',
      branchPlaceholder: '自动生成',
      branchCode: '银行联行号',
      branchCodePlaceholder: '自动生成',
      bankGroup: '银行组',
      bankGroupPlaceholder: '自动生成',
      swiftCode: 'SWIFT码',
      swiftCodePlaceholder: '自动生成',
      bankAccountNum: '银行账户号码',
      bankAccountNumPlaceholder: '请输入银行账户号码',
      bankAccountName: '银行账户',
      bankAccountNamePlaceholder: '请输入银行账户',
      bankAccountDesc: '账户描述',
      bankAccountDescPlaceholder: '请输入账户描述',
      classCode: '账户属性',
      classCodePlaceholder: '请选择账户属性',
      secondaryClassCode: '账户二级属性',
      secondaryClassCodePlaceholder: '请选择账户二级属性',
      generalLedgerAccount: '总账科目',
      generalLedgerAccountPlaceholder: '请选择总账科目',
      currencyCode: '账户币别',
      currencyCodePlaceholder: '请选择账户币别',
      bankConnectionFlag: '银企直联标识',
      creditLine: '授信额度',
      createBy: '创建人',
      createByPlaceholder: '自动生成',
      bankAccountStatus: '账户状态',
      bankAccountStatusPlaceholder: '自动生成',
      clMarginRate: '开证保证金比例%',
      clIssueCostRate: '开证费用比例%',
      clAcceptanceCostRate: '承兑费用比例%',
      gmtCreate: '创建日期',
      gmtCreatePlaceholder: '自动生成',
      lastModifiedBy: '最后修改人',
      lastModifiedByPlaceholder: '自动生成',
      gmtModified: '最后修改日期',
      gmtModifiedPlaceholder: '自动生成',
      sapBankCode: 'sap银行编码',
      sapBankCodePlaceholder: '请输入sap银行编码',
      sapBankAccountCode: 'sap银行账户编码',
      sapBankAccountCodePlaceholder: '请输入sap银行账户编码',
    },
    btnList: {
      save: '保存',
    },
    msg: {
      lack: '缺少',
      saveSussess: '保存成功！',
      bankMaintain: '该条银行数据不完整，请检查并完善该条银行数据！',
    },
  },
};
